import React, { useCallback, useMemo } from 'react';

import { useAppSelector } from '../../../../hooks/react-redux';
import { ContinentGraphData, ContinentMap } from '../../../shared/analytics/ContinentMap';
import { Spinner } from '../../../shared/spinner/Spinner';
import { getContinentGeometryJSON, getCounterpartyJurisdictionAnalytics, getFetchingAnalytics } from '../../store';
import styles from '../Modules.module.scss';
import { worldCountriesList } from '../../../constants/worldCountriesList';
import { HomePageChart } from '../../../auth/login/store';

interface EntitySpreadMapProps {
    dimensions: {
        height: number;
        width: number;
    }
    analyticsSpinner: boolean;
    reduceMapHeight: boolean;
}

const edgeCaseJurisdictions = ['US'];

export const EntitySpreadMap: React.FC<EntitySpreadMapProps> = ({ dimensions, analyticsSpinner, reduceMapHeight }) => {
    const continentGeometry = useAppSelector(getContinentGeometryJSON);
    const data = useAppSelector(getCounterpartyJurisdictionAnalytics);
    const fetchingAnalytics = useAppSelector(getFetchingAnalytics);
    const showSpinner = useMemo(() => fetchingAnalytics.includes(HomePageChart.ENTITY_JURISDICTION) || continentGeometry.length === 0 || analyticsSpinner, [continentGeometry.length, analyticsSpinner, fetchingAnalytics]);
    const mapDimensions = useMemo(() => ({ height: (dimensions.height * (reduceMapHeight ? 0.6 : 1)) - 50, width: dimensions.width }), [dimensions, reduceMapHeight]);

    const getDocumentsByCountry = useCallback((id: string) => data.filter(({ jurisdiction }) => edgeCaseJurisdictions.includes(id) ? jurisdiction?.includes(id) : jurisdiction === id).reduce((acc, cur) => acc + cur.documents, 0), [data]);
    const graphData: ContinentGraphData[] = useMemo(() => worldCountriesList.map(country => ({ value: getDocumentsByCountry(country.id), ...country, disabled: false })), [getDocumentsByCountry]);

    return (
        <div className={styles.continentMapWrapper} style={{ height: `${dimensions.height}px`, width: `${dimensions.width}px` }}>
            {showSpinner ? <Spinner /> : <ContinentMap key='entity-spread-map' id='document-entities' continentGeometry={continentGeometry} graphData={graphData} height={mapDimensions.height} width={mapDimensions.width} />}
            <div className={styles.chartHeader}>
                <div className={styles.chartTitle}>Jurisdiction Map</div>
            </div>
        </div>
    );
};
